"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { user } from "Models/UserModel";
import { Map } from 'immutable';

var FormStateManager =
/*#__PURE__*/
function () {
  /**
   * @type {Map<string, any>}
   * @private
   */
  function FormStateManager(_ref) {
    var formID = _ref.formID;

    _classCallCheck(this, FormStateManager);

    _defineProperty(this, "_formID", void 0);

    _defineProperty(this, "_state", new Map());

    this._formID = formID;
    this.load();
  }
  /**
   * @return {string}
   */


  _createClass(FormStateManager, [{
    key: "getProperty",

    /**
     * @param {string} key
     * @return {any}
     */
    value: function getProperty(key) {
      return this._state.get(key);
    }
    /**
     * @param {string} key
     * @param value
     */

  }, {
    key: "setProperty",
    value: function setProperty(key, value) {
      this._state = this._state.set(key, value);
    }
    /**
     * @return {Map<string, any>}
     */

  }, {
    key: "load",
    value: function load() {
      this._state = new Map(JSON.parse(localStorage.getItem(this.lsName) || '{}'));
      return this._state;
    }
  }, {
    key: "write",
    value: function write() {
      localStorage.setItem(this.lsName, JSON.stringify(this._state.toObject()));
    }
  }, {
    key: "lsName",
    get: function get() {
      return "".concat(user.getUserID(), "-formID-").concat(this._formID);
    }
  }]);

  return FormStateManager;
}();

export { FormStateManager as default };